import { takeEvery } from 'redux-saga/effects';
import { REPORT_A_BUG_START } from 'redux/actions/types';
import { reportABug } from './report-a-bug-saga';

export default function* pictureSagas() {
  yield takeEvery(REPORT_A_BUG_START, reportABug);
}
